import { render, staticRenderFns } from "./browse-trending-mixes.vue?vue&type=template&id=474871b6&"
import script from "./browse-trending-mixes.vue?vue&type=script&lang=js&"
export * from "./browse-trending-mixes.vue?vue&type=script&lang=js&"
import style0 from "./browse-trending-mixes.vue?vue&type=style&index=0&id=474871b6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports